import { configureStore } from '@reduxjs/toolkit';

import { initialState, reducer } from './reducer';

export const store = configureStore({
	reducer: reducer(initialState),
	devTools: {
		name: 'fastshift/global',
	},
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
